<form [formGroup]="adcSettingsForm">
  <div class="card card-default h-100 mb-3">

    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <span class="h5 mb-0" [innerText]="getAdcHeader(adc.index)"></span>
        </div>
        <div class="col-auto">
          <button aria-label="remove signal" class="btn btn-outline-danger btn-sm ng-scope"
            (click)="remove(adc)" title="Remove signal">
            <span class="fa-solid fa-trash" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <!-- ADC SIGNAL NAME -->
      <div class="form-group">
        <label translate>Name</label>
        <input name="name" formControlName="signalName" type="text" class="form-control" (focusout)="onFocusOut()"
          [ngClass]="{'is-invalid': formControls.signalName.errors}">
          @if (formControls.signalName.errors) {
            <div class="invalid-feedback">
              @if (formControls.signalName.errors.required) {
                <span translate>Signal requires a unique name</span>
              }
            </div>
          }
        </div>

        <!-- ADC INDEX -->
        <div class="form-group">
          <label translate>Index</label>
          <ng-select id="adcIndex" name="adcIndex" formControlName="adcIndex"
            [items]="availableIndices" (change)="changeIndex($event)"
            (focusout)="onFocusOut()">
          </ng-select>
        </div>

        <!-- ADC INPUT/OUTPUT TYPE -->
        <div class="form-group">
          <label translate>Input/output type</label>
          <ng-select id="adcIoType" name="adcIoType" formControlName="adcIoType" (change)="onFocusOut()"
            (focusout)="onFocusOut()" [items]="ioTypes">
          </ng-select>

        </div>

        <!-- ADC SCALE MIN -->
        @if (isAnalogIOType()) {
          <div class="form-group">
            <label translate>Scale value at 4mA</label>
            <input name="scaleMin" formControlName="scaleMin" type="number" class="form-control" (focusout)="onFocusOut()"
              [ngClass]="{'is-invalid': formControls.scaleMin.errors}">
              @if (formControls.scaleMin.errors) {
                <div class="invalid-feedback">
                  @if (formControls.scaleMin.errors.required) {
                    <span translate>Signal requires scale value at 4mA</span>
                  }
                </div>
              }
            </div>
          }

          <!-- ADC SCALE MAX -->
          @if (isAnalogIOType()) {
            <div class="form-group">
              <label translate>Scale value at 20mA</label>
              <input name="scaleMax" formControlName="scaleMax" type="number" class="form-control" (focusout)="onFocusOut()"
                [ngClass]="{'is-invalid': formControls.scaleMax.errors}">
                @if (formControls.scaleMax.errors) {
                  <div class="invalid-feedback">
                    @if (formControls.scaleMax.errors.required) {
                      <span translate>Signal requires scale value at 20mA</span>
                    }
                  </div>
                }
              </div>
            }

            <!-- ADC Hysteresis -->
            <div class="form-group">
              <label translate>Hysteresis</label><label> [&mu;A]</label>
              <input name="hysteresis" formControlName="adcHysteresis" type="number"
                [min]="HYSTERESIS_RANGE_MIN" [max]="HYSTERESIS_RANGE_MAX"
                class="form-control"
                (focusout)="onFocusOut()"
                [ngClass]="{'is-invalid': formControls.adcHysteresis.errors}">
                @if (formControls.adcHysteresis.errors) {
                  <div class="invalid-feedback">
                    @if (formControls.adcHysteresis.errors.required || formControls.adcHysteresis.errors.min || formControls.adcHysteresis.errors.max) {
                      <span
                      translate>Hysteresis should be between 10 and 1000</span>
                    }
                  </div>
                }
              </div>

            </div>
          </div>
        </form>